import { jsx as _jsx } from "react/jsx-runtime";
import { Tour as ANTDTour, } from 'antd';
import { useTheme } from '../../providers';
export function Tour({ open = true, steps, showArrow = true, mask = false, variant, onClose, }) {
    const theme = useTheme();
    const newSteps = steps.map((step) => {
        if (variant === 'noImage') {
            return Object.assign(Object.assign({}, step), { cover: null });
        }
        return step;
    });
    return (_jsx(ANTDTour, { open: open, arrow: showArrow, closeIcon: null, steps: newSteps, mask: mask, onClose: onClose }));
}
//# sourceMappingURL=Tour.js.map